import { useTranslation } from "react-i18next";
import "./App.css";

interface AIRoomEmptyStateProps {
  roomName: string;
  isGenerating: boolean;
  setAIRoomState: (state: string) => void;
  onGenerate: () => void;
}

function AIRoomEmptyState({
  roomName,
  isGenerating,
  setAIRoomState,
  onGenerate,
}: AIRoomEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className="App-header">
      <div className="container-row lift-topbar">
        <div className="container-row-start">
          <div
            className="button-tertiary-m button-text-m text-color-black"
            onClick={() => setAIRoomState("lobby")}
            style={{ maxHeight: "32.5px" }}
          >
            {t("back")}
          </div>
        </div>
        <div className="text-h3 text-color-black left-margin-s text-force-break">
          {roomName}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <p className="text-h1 text-color-black">{t("ai.empty.title")}</p>
      </div>

      <div
        className="button-primary black-fill button-text-l text-color-pink shadow-pink box-button-center"
        onClick={onGenerate}
        style={{
          opacity: isGenerating ? 0.5 : 1,
          pointerEvents: isGenerating ? "none" : "auto",
        }}
      >
        {isGenerating ? t("ai.generating") : t("ai.empty.generate")}
      </div>
    </div>
  );
}

export default AIRoomEmptyState;
